import { useEffect, useMemo, useCallback } from "react";
import { checkAdmin } from "../utils/jwtUtils";
import { fetchGroup, fetchNoGroup } from "../services/groupService";
import { fetchExaminer } from "../services/examinerService";
import { useElemContext } from "../Contexts/ElemContext";
import { useFeedback } from "../Contexts/FeedbackContext";
import { ERROR_UNEXPECTED } from "../constants/feedbacks";

export function useSideBarData(pathname) {
  const { showFeedback } = useFeedback();
  const { search, groups, setGroups, examiners, setExaminers } =
    useElemContext();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (pathname === "/student") {
          const groupsRes = await fetchGroup();
          let groupsData = groupsRes.data;

          if (checkAdmin()) {
            const noGroupRes = await fetchNoGroup();
            groupsData = {
              ...groupsData,
              "Sans Groupe": { id: null, students: noGroupRes.data },
            };
          }
          setGroups(groupsData);
        }
        if (pathname === "/examiner") {
          const res = await fetchExaminer();
          setExaminers(res.data);
        }
      } catch {
        showFeedback(ERROR_UNEXPECTED, false);
      }
    };
    fetchData();
  }, [pathname, setGroups, setExaminers, showFeedback]);

  const filterList = useCallback(
    (list) => {
      if (!search || !list) return list;
      return list.filter((item) =>
        (item.surname || item.name).toLowerCase().includes(search.toLowerCase())
      );
    },
    [search]
  );

  const filteredGroups = useMemo(() => {
    if (pathname !== "/student" || !groups) return [];
    return Object.keys(groups)
      .map((groupName) => {
        const students = filterList(groups[groupName].students);
        return students.length
          ? { id: groups[groupName].id, name: groupName, students }
          : null;
      })
      .filter(Boolean);
  }, [pathname, groups, filterList]);

  const filteredExaminers = useMemo(() => {
    if (pathname !== "/examiner" || !examiners) return [];
    return filterList(Object.values(examiners));
  }, [pathname, examiners, filterList]);

  return { filteredGroups, filteredExaminers };
}
